/**
 * Insights Chat deep link — redirects to Insights and opens global Mojo Agent panel (012).
 */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMojoAgent } from '../contexts/MojoAgentContext';

export function InsightsChatPage(): React.ReactElement | null {
  const navigate = useNavigate();
  const { open } = useMojoAgent();

  useEffect(() => {
    navigate('/insights', { replace: true });
    open();
  }, [navigate, open]);

  return null;
}
